import React from 'react'

const FormTitle = (props) =>{
  return(
    <div className="form-title">
      <h1 className="heading-2">Salesforce Scoping <br /> Request Form</h1>
    </div>
  )
}

export default FormTitle



// WEBPACK FOOTER //
// ./src/components/FormTitle.js